import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppService } from 'app/app.service';
import { canUseFeature } from 'app/guards/features.guard';
import { NavigationService } from 'app/services';
import { filter, first, map } from 'rxjs';

/** 
 * The Admin is a little different to other features. The feature setting applies only to 'client' users. 
 * Any other user will have admin enabled by default, regardless of the setting. 
 */
export const adminGuard: CanActivateFn = () => {
    const appService = inject(AppService);
    const navigation = inject(NavigationService);

    return appService.client$.pipe(
        filter(client => !!client),
        first(),
        map(() => canUseFeature(appService.features.page.admin.enabled, appService.user, navigation.getDefaultUrlTree(), ['vendor', 'distributor', 'system']))
    );
}
